import React from "react";
import PropTypes from "prop-types";
import { Modal, Dimmer, Loader } from "semantic-ui-react";

/**
 * A common way to show a full screen loading indicator.
 * Note this component also exists in the SPA project. TODO unify
 */
export default function LoadingWrapper({ loading, message, children }) {
  return (
    <div>
      <Modal open={loading} basic size="small" dimmer="inverted" className="semantic-ui">
        <Dimmer inverted active>
          <Loader>{message}</Loader>
        </Dimmer>
      </Modal>
      {children}
    </div>
  );
}

LoadingWrapper.propTypes = {
  loading: PropTypes.bool.isRequired,
  message: PropTypes.string,
  children: PropTypes.node,
};

LoadingWrapper.defaultProps = {
  message: "",
};
